import {
  MessageAttributeValue,
  SQSClient,
  SendMessageCommand,
} from "@aws-sdk/client-sqs"
import { refCountry } from "@tc/drizzle-v2"
import { DbTransaction } from "@tc/middy-decorators"
import { and, eq } from "drizzle-orm"

const sqs_client = new SQSClient({})
const queue_url = process.env["QUEUE_URL"]

export type countriesV2Doc = {
  id: string
  alpha_2_code: string | null
  label: string | null
  name: string | null
  subregion: string | null
  region: string | null
  continent: string | null
  capital: string | null
  dial: string | null
  short_name_en: string | null
  active: boolean | null
}

export const getCountriesV2Data = async (
  tx: DbTransaction,
  countryId: string,
): Promise<countriesV2Doc | undefined> => {
  const [row] = await tx
    .select({
      id: refCountry.id,
      itemCode: refCountry.itemCode,
      itemName: refCountry.itemName,
      active: refCountry.active,
      updatedAt: refCountry.updatedAt,
      updatedBy: refCountry.updatedBy,
      subregion: refCountry.subregion,
      region: refCountry.region,
      continent: refCountry.continent,
      capital: refCountry.capital,
      dial: refCountry.dial,
      short_name_en: refCountry.short_name_en,
    })
    .from(refCountry)
    .where(and(eq(refCountry.id, parseInt(countryId))))

  if (!row) {
    console.error(`country with id ${countryId} not found`)
    return
  }

  const countriesDoc: countriesV2Doc = {
    id: row.itemCode,
    alpha_2_code: row.itemCode ?? "",
    label: row.short_name_en ?? row.itemName ?? "",
    name: row.itemName ?? "",
    subregion: row.subregion ?? "",
    region: row.region ?? "",
    continent: row.continent ?? "",
    capital: row.capital ?? "",
    dial: row.dial ?? "",
    short_name_en: row.short_name_en ?? "",
    active: row.active,
  }

  return countriesDoc
}

export const saveCountriesV2ToSearch = async (
  tx: DbTransaction,
  id: string,
  collectionName: string,
  options?: { returnDoc?: boolean },
): Promise<void> => {
  const doc = await getCountriesV2Data(tx, id)

  if (!doc || Object.keys(doc).length === 0) {
    console.error(`Failed to prepare document for id: ${id}`)
    return
  }

  if (options?.returnDoc) return doc as never

  const attributes: Record<string, MessageAttributeValue> = {
    collection: {
      StringValue: collectionName,
      DataType: "String",
    },
  }

  const command = new SendMessageCommand({
    QueueUrl: queue_url,
    MessageBody: JSON.stringify(doc),
    MessageAttributes: attributes,
  })

  await sqs_client.send(command)
}
